(function () {
  'use strict';

  function init() {
    var settings = window.theme && window.theme.settings;
    if (!settings || !settings.globalDiscountEnabled) return;

    var pct = parseFloat(settings.globalDiscountPercentage) || 0;
    if (pct <= 0 || pct >= 100) return;

    var moneyFormat = settings.moneyFormat;
    var badgeText = settings.globalDiscountBadgeText || '';

    function fmt(cents) {
      return theme.Currency.formatMoney(Math.round(cents), moneyFormat);
    }

    function discounted(originalCents) {
      return Math.round(originalCents * (1 - pct / 100));
    }

    // --- Grid / collection price elements ---
    document.querySelectorAll('.grid-product__price[data-price-cents]').forEach(function (el) {
      if (el.getAttribute('data-discount-applied')) return;

      var priceCents = parseInt(el.getAttribute('data-price-cents'), 10);
      var compareCents = parseInt(el.getAttribute('data-compare-cents'), 10) || 0;
      if (!priceCents) return;

      // Use existing compare price if already on sale, otherwise use original price
      var displayOriginal = compareCents > priceCents ? compareCents : priceCents;
      var displayFinal = discounted(priceCents);

      el.innerHTML =
        '<span class="grid-product__price--original" style="text-decoration:line-through; opacity:0.6; margin-right:4px;">' +
          fmt(displayOriginal) +
        '</span>' +
        '<span class="grid-product__price--sale" style="color:var(--color-savings-text, #ff4e4e);">' +
          fmt(displayFinal) +
        '</span>';

      el.setAttribute('data-discount-applied', 'true');
    });

    // --- Product page ---
    applyProductPage(null);

    // Re-apply after theme JS updates price on variant change
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      applyProductPage(variant ? variant.price : null);
    });
  }

  function applyProductPage(variantPriceCents) {
    var settings = window.theme && window.theme.settings;
    if (!settings || !settings.globalDiscountEnabled) return;

    var pct = parseFloat(settings.globalDiscountPercentage) || 0;
    if (pct <= 0 || pct >= 100) return;

    var moneyFormat = settings.moneyFormat;

    function fmt(cents) {
      return theme.Currency.formatMoney(Math.round(cents), moneyFormat);
    }

    function discounted(cents) {
      return Math.round(cents * (1 - pct / 100));
    }

    var priceEl = document.querySelector('[data-product-price]');
    if (!priceEl) return;

    // Get current price in cents: from argument (variant change) or data attribute
    var priceCents = variantPriceCents !== null && variantPriceCents !== undefined
      ? variantPriceCents
      : parseInt(priceEl.getAttribute('data-price-cents'), 10);

    if (!priceCents) return;

    // Keep the cents updated for future variant changes that don't pass a value
    priceEl.setAttribute('data-price-cents', priceCents);

    var finalCents = discounted(priceCents);
    priceEl.innerHTML = fmt(finalCents);

    // Show original price as compare price if no existing compare price is shown
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var priceWrapEl = document.querySelector('[data-product-price-wrap]');

    if (comparePriceEl) {
      var alreadyOnSale = comparePriceEl.textContent.trim() !== '';
      if (!alreadyOnSale) {
        comparePriceEl.innerHTML = fmt(priceCents);
        priceEl.classList.add('on-sale');
        if (priceWrapEl) priceWrapEl.classList.remove('hide');
        var a11yEl = document.querySelector('[data-compare-price-a11y]');
        if (a11yEl) a11yEl.removeAttribute('aria-hidden');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
